/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="84.32" viewBox="0 0 95.58 84.32" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M98.53,35a26.12,26.12,0,0,0-18,7.63l-3.24,3.25-3.24-3.25A26.29,26.29,0,0,0,36.61,43c-9.83,10.24-9.38,26.73.8,36.92l39,39a1.25,1.25,0,0,0,1.77,0l39-39c10.18-10.19,10.63-26.68.8-36.91a26.2,26.2,0,0,0-19-8ZM99,37.5a23.71,23.71,0,0,1,17.17,7.28l.28.29c8.58,9.26,8.09,24-1,33.12L77.29,116.3,39.18,78.19C30,69,29.54,54,38.41,44.78a23.78,23.78,0,0,1,33.87-.38l4.13,4.13a1.26,1.26,0,0,0,1.77,0L82.3,44.4A23.6,23.6,0,0,1,99,37.5Z" transform="translate(-29.5 -35)" fill="#0e497b"/><polygon points="71.32 15.09 71.32 24.28 80.51 24.28 80.51 34.25 71.32 34.25 71.32 43.44 61.34 43.44 61.34 34.25 52.16 34.25 52.16 24.28 61.34 24.28 61.34 15.09 71.32 15.09" fill="#ffb81c" fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HeartWithCrossIcon';

export default Icon;
